import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { alpha } from '@mui/material/styles';
import { brand } from "src/templates/shared-theme/themePrimitives";

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

// type Props = {
//   plan: IPricingHomeProps;
// };
//
// export type IPricingHomeProps = {
//   license: string;
//   price: string;
//   icons: string[];
//   commons: string[];
//   options: {
//     title: string;
//     disabled: boolean;
//   }[];
// };

// ----------------------------------------------------------------------

export default function PricingHomeCard({ plan, optionIndex }) {
  const transparent = (opacity) => alpha(brand[300], opacity);

  return (
    <Card
      sx={{
        mx: { xs: 4, md: 0 },
        py: 4,
        boxShadow: `-8px 8px 24px -4px ${transparent(0.08)}`,
        ...({
          boxShadow: `-24px 24px 72px -8px ${transparent(0.24)}`,
        }),
      }}
    >
      <Stack spacing={5}>
        <Stack
          direction='row'
          sx={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="h4" >
            S$
          </Typography>
          <Typography variant="h2" sx={{ display: 'block' }}>
            {plan.amount}
          </Typography>
        </Stack>

        <Stack spacing={1} sx={{ textAlign: 'center' }}>
          {
            plan.bonus > 0 ? (
              <Typography
                variant="body1"
              >
                Free S${plan.bonus}
              </Typography>
            ) : (
              <Typography variant="body1">&nbsp;</Typography>
            )
          }
          <Stack
            direction='row'
            sx={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography sx={{ fontSize: '1.1rem' }} >
              Get S$
            </Typography>
            <Typography sx={{ fontSize: '1.3rem' }} >
              {plan.amount + plan.bonus}
            </Typography>
          </Stack>
        </Stack>

        <Stack alignItems="center" spacing={3}>
          <Button
            size="large"
            fullWidth
            variant='outlined'
            color='secondary'
            href={`/topup?optionIndex=${optionIndex}`}
            sx={{
              maxWidth: 200,
            }}
          >
            Buy
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}
